<template>
  <v-card height="100vh">
    <v-navigation-drawer
      color="teal"
      absolute
      dark
      class="sidedrawer"
      permanent
      v-if="!isLogin"
    >
      <v-list dense nav class="py-0">
        <v-list-item three-line>
          <span
            style="
              padding: 5px;
              border-radius: 50px;
              background: #fff;
              margin-right: 12px;
            "
          >
            <img
              src="../../assets/logo.png"
              width="40px"
              height="40px"
              style="display: block"
            />
          </span>
          <h3>Hybridy Battery Swap</h3>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="item.path"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-content v-if="isLogin">
      <v-content class="app-content">
        <slot></slot>
      </v-content>
    </v-content>
    <v-content v-else style="margin-left: 256px">
      <v-app-bar color="teal" dense dark>
        <h3>Cells | Battery | Sales Management</h3>
        <v-spacer></v-spacer>

        <div class="mr-2 ml-1">
          <div class="d-flex align-center">
            <strong class="mr-2">OFFICE :</strong>
            <v-select
              v-model="location"
              :items="locations"
              :onChange="handlelocationChange"
              @change="handlelocationChange"
              hide-details
              dense
            ></v-select>
          </div>
        </div>
        <v-menu left bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="n of dropDown"
              :key="n.title"
              @click="tableActions(n)"
            >
              <v-list-item-title>{{ n.title }}</v-list-item-title>
            </v-list-item>
            <v-list-item color="primary" class="mr-4" rounded @click="logout()">
              Logout
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
      <v-content class="app-content">
        <slot></slot>
      </v-content>
    </v-content>
    <v-btn
      v-if="!isLogin"
      color="yellow"
      fab
      large
      dark
      bottom
      left
      fixed
      to="/addcells"
    >
      <v-icon color="grey">add</v-icon>
    </v-btn>
  </v-card>
</template>
<script>
import { createSimple, download } from "../../directive/ExportToCSV";
import api from "@/api";
import { getAllOfficeLocations, setOfficeLocation } from "../../utils/officeLocation";

export default {
  computed: {
    isLogin() {
      const loginurl =
        this.$route.fullPath == "/login" ||
        this.$route.fullPath == "/login/forgotpassword" ||
        this.$route.path == "/login/resetpassword/" ||
        this.$route.path == "/login/resetpassword";

      //    console.log(this.$route);
      return loginurl;
    },
  },
  name: "MainLayout",
  data: () => ({
    location: "",
    locations: [],
    items : [],
  }),
  watch: {
    isLogin: {
      handler: function(newVal) {
        if (!newVal && this.items.length == 0) {
          this.fetchSideMenu();
        }
        if (!newVal && this.locations.length == 0) {
          this.fetchLocations();
        }
        
      },
      immediate: true,
    }
  },
  created() {
    this.dropDown = [
      { gen: 2, title: "Download Gen 2", action: "download" },
      { gen: 2, title: "Purge Gen 2", action: "purge" },
      { gen: 1, title: "Download Gen 1", action: "download" },
      { gen: 1, title: "Purge Gen 1", action: "purge" },
    ];

    this.right = null;
  },
  methods: {
    async tableActions(item) {
      if (item.action == "download") {
        const { data } = await api.getAllCells(item.gen);
        const string = createSimple(data);
        download(string);
      }

      if (item.action == "purge") {
        await api.deleteAllCells(item.gen);
        this.$toast.success({ title: "Cells Deleted Successfully" });
      }
    },
    logout() {
      this.$cookies.remove("token");
      this.$router.push("/login");
    },
    handlelocationChange(location) {
      setOfficeLocation(location);
    },
    async fetchSideMenu() {
      const response = await api.getSideMenu();
      this.items = response.data;
    },
    async fetchLocations() {
      this.locations = await getAllOfficeLocations();
    },
  },
  mounted() {
    this.location = this.selectedLocation;
  },
};
</script>
<style scoped>
.app-content {
  height: calc(100vh - 48px);
  overflow: auto;
}
</style>